const ONES = [
  "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine",
  "ten", "eleven", "twelve", "thirteen", "fourteen", "fifteen", "sixteen",
  "seventeen", "eighteen", "nineteen",
];
const TENS = [
  "", "", "twenty", "thirty", "forty", "fifty", "sixty", "seventy", "eighty", "ninety",
];
const SCALES = [
  { value: 1_000_000_000, name: "billion" },
  { value: 1_000_000, name: "million" },
  { value: 1_000, name: "thousand" },
  { value: 100, name: "hundred" },
];

function threeDigitsToWords(n: number): string {
  if (n === 0) return "";
  if (n < 20) return ONES[n];
  if (n < 100) {
    const tens = TENS[Math.floor(n / 10)];
    const rest = n % 10;
    return rest ? `${tens}-${ONES[rest]}` : tens;
  }
  const hundreds = Math.floor(n / 100);
  const rest = n % 100;
  return rest
    ? `${ONES[hundreds]} hundred ${threeDigitsToWords(rest)}`
    : `${ONES[hundreds]} hundred`;
}

export function numberToWords(amount: number): string {
  const value = Math.round(Math.abs(amount));
  if (value === 0) return "zero";

  let remaining = value;
  const parts: string[] = [];

  for (const scale of SCALES) {
    if (remaining >= scale.value) {
      const count = Math.floor(remaining / scale.value);
      remaining %= scale.value;
      parts.push(`${threeDigitsToWords(count)} ${scale.name}`);
    }
  }
  if (remaining > 0) parts.push(threeDigitsToWords(remaining));

  return parts.join(" ").replace(/\s+/g, " ").trim();
}

export function amountInWordsTaka(amount: number): string {
  return `Taka. ${numberToWords(amount)} only.`;
}
